import { hexSchema, type Hex } from '@hoodmorning/contracts';
import { decodeFunctionData, encodeFunctionData, keccak256, parseAbi } from 'viem';

export const routerExecuteAbi = parseAbi(['function execute(bytes commands,bytes[] inputs,uint256 deadline) payable']);

/** Version-independent envelope checks only. The caller must use its exact
 * version-specific SDK parser, then independently enforce trade policy. */
export function inspectCanonicalRouterEnvelope(data: Hex, nowUnixSeconds: bigint) {
  hexSchema.parse(data);
  if (data.length > 131074) throw new Error('Router calldata exceeds preparation bound');
  const decoded = decodeFunctionData({ abi: routerExecuteAbi, data });
  const [commands, inputs, deadline] = decoded.args;
  const count = (commands.length - 2) / 2;
  if (count === 0 || count > 32 || inputs.length !== count) throw new Error('Router command/input count mismatch');
  if (deadline <= nowUnixSeconds) throw new Error('Router execution expired');
  for (let i = 2; i < commands.length; i += 2) {
    if ((Number.parseInt(commands.slice(i, i + 2), 16) & 0xc0) !== 0) throw new Error('Unsupported router command flags');
  }
  const canonical = encodeFunctionData({ abi: routerExecuteAbi, functionName: 'execute', args: [commands, [...inputs], deadline] });
  if (canonical.toLowerCase() !== data.toLowerCase()) throw new Error('Noncanonical router calldata');
  return { calldataHash: keccak256(data), deadline, count };
}
